export const FETCH_LEX_DATA = 'FETCH_LEX_DATA';
export const FETCHING_LEX = 'FETCHING_LEX';
export const FETCHING_LEX_SUCCESS = 'FETCHING_LEX_SUCCESS';
export const FETCHING_LEX_ERROR = 'FETCHING_LEX_ERROR';
export const SET_IS_ENROLLED = 'SET_IS_ENROLLED';
export const SET_LEX_LASTLAUNCHED = 'SET_LEX_LASTLAUNCHED';
